export const pipe = (...functions) => arg =>
    functions.reduce((accum, func) => func(accum), arg);

export const hasOwnProperty = (target, key) => {
    return Object.prototype.hasOwnProperty.call(target, key);
};

export const createDownload = elem => {
    fetch(elem.url).then(response => {
        response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = `${elem.name}.pdf`;
            a.click();
        });
    });
};

// Функция перемешивания методом Фишера-Йетса
export const shuffle = array => {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
};
